module.exports = __webpack_public_path__ + "img/59_10.dc78464a.png";